"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = require("react-emotion");

var _styleConsts = require("../utils/styleConsts");

var _hexToRgb = _interopRequireDefault(require("../utils/hexToRgb"));

/* const fadeIn = keyframes`
  from { opacity: 0.2 }
  to   { opacity:   1 }
`;

const goUp = keyframes`
  from { transform: translateY(-50%) }
  to   { transform: translateY(  0%) }
`; */
var overlay = function overlay(theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:fixed;top:0;bottom:0;left:0;right:0;display:flex;justify-content:center;align-items:center;background-color:rgba(", (0, _hexToRgb.default)(theme.color.black1), ",0.7);z-index:1000;")
  );
};

var popup = function popup(theme, stickyHeader, stickyFooter) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("min-width:640px;background-color:", theme.color.white, ";color:", theme.color.black1, ";border-radius:", _styleConsts.borderRadius, ";", (stickyHeader || stickyFooter) && "\n    position: relative;\n  ", "\n  @media (max-width:767px){min-width:90%;margin:0 5%;}")
  );
}; // animation: ${goUp} 0.5s;


var header = function header(theme, sticky) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;justify-content:space-between;line-height:64px;min-height:64px;padding:0 25px 0 40px;font-size:", _styleConsts.font.size.xl, ";font-weight:500;border-bottom:1px solid ", theme.color.grey2, ";fill:", theme.color.black3, ";", sticky ?
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:absolute;left:0px;right:0px;top:0px;background-color:", theme.color.white, ";z-index:2;") : null, ";")
  );
};

var body = function body(stickyHeader, stickyFooter) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("height:100%;", stickyHeader && !stickyFooter ?
    /*#__PURE__*/
    (0, _reactEmotion.css)("padding-top:65px;overflow:auto;box-sizing:border-box;") : null, ";", !stickyHeader && stickyFooter ?
    /*#__PURE__*/
    (0, _reactEmotion.css)("padding-bottom:77px;overflow:auto;box-sizing:border-box;") : null, ";")
  );
};

var headerButton = function headerButton(theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("fill:", theme.color.black3, ";transform:scale(1.2);")
  );
};

var main = function main(theme, stickyHeader, stickyFooter) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("padding:16px 40px;", stickyHeader && stickyFooter ?
    /*#__PURE__*/
    (0, _reactEmotion.css)("padding:80px 40px 93px;overflow:auto;height:100%;box-sizing:border-box;") : null, ";")
  );
};

var footer = function footer(theme, sticky) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;justify-content:space-between;align-items:center\n  padding:16px 40px;z-index:2;border-top:1px solid ", theme.color.grey2, ";button{margin-left:16px;}", sticky ?
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:absolute;left:0px;right:0px;bottom:0px;background-color:", theme.color.white, ";") : null, ";")
  );
};

var footerText = function footerText(theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("color:", theme.color.black2, ";")
  );
};

var headerBackButtonTitle = function headerBackButtonTitle() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;")
  );
};

var headerText = function headerText() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("margin:0;")
  );
};

var _default = {
  overlay: overlay,
  popup: popup,
  header: header,
  headerButton: headerButton,
  main: main,
  footer: footer,
  body: body,
  footerText: footerText,
  headerBackButtonTitle: headerBackButtonTitle,
  headerText: headerText
};
exports.default = _default;